module.exports = __webpack_public_path__ + "static/media/icons_Bilan Guillarme - Algies Pelvi-périnéo-pudendales.c37c2ac9.svg";